import {
  Card as CXCard,
  CardMedia as CXCardMedia,
  CardContent as CXCardContent
} from '@sanlamcx/react-ui-next-card';

type Card = typeof CXCard;
type CardMedia = typeof CXCardMedia;
type CardContent = typeof CXCardContent;

export const Card: Card = CXCard;
export const CardMedia: CardMedia = CXCardMedia;
export const CardContent: CardContent = CXCardContent;
